export default {
	head: {
		title: 'Blumar - Online Reservation',
		description: '',
		keywords: 'Blumar Reservas Online',
		ogDescription: '',
	},
	navbar: {
		makeBookings: "Faça sua Reserva",
		seeBookings: "Veja suas Reservas",
		exit: 'Sair',
		cart: 'Carrinho de Compras'
	},
	loginArea: {
		user: 'Login',
		pass: 'Senha',
		enter: 'Entrar',
		errorMsg: 'Usuario ou senha invalidos'
	},
	searchArea: {
		destination: 'Cidade ou Nome do Hotel',
		checkin: 'Data de Entrada',
		checkout: 'Data de Saída',
		rooms: 'Quartos',
		adults: 'Adultos',
		children: 'Crianças',
		age: 'Idade',
		search: 'Buscar',

		destinationNotFound: 'Nenhum destino encontrado.',
		resultNotFound: 'Nenhum resultado encontrado.',
		invalidFields: 'Preencha o(s) campo(s): ',

		hotel: 'Hotel',
		city: 'Cidade',
		specialDestination: 'Destino Especial',
		more: 'Mais Sobre',
		book: 'Reservar',

		sortBy: 'ORDENAR POR',
		hotelNameUpperCase: 'NOME',
		starsUpperCase: 'ESTRELAS',
		priceUpperCase: 'PREÇO',

		resultsText: (total, pages) => `Foram encontrados ${total} hotéis em ${pages} páginas.`,
		pagination: {
			first: 'Primeira',
			prev: 'Anterior',
			next: 'Próxima',
			last: 'Ultima',
		},

		filters: 'FILTROS',
		hotelName: 'Nome do Hotel',
		stars: 'Estrelas',
		price: 'Preço',
		district: 'Bairro',
		clearButton: 'Limpar',

		hotelFacilities: 'Facilidades do Hotel',
		hotelLocation: 'Localização do Hotel',
		roomsFacilities: 'Facilidades do Quarto',

		mealPlans: {
			noMeals: 'Sem Café',
			Breakfast: 'Café da Manhã',
			Map: 'Meia Pensão',
			Fap: 'Pensão Completa',
			AllInclusive: 'All Inclusive'
		},

		confirmation: {
			bookingDetails: 'Detalhes da Reserva',
			meal: 'Refeições Inclusas',
			roomCategory: 'Categoria de Apartamento',
			room: 'Quarto',
			taxObs: 'Todas as taxas obrigatorias estão inclusas',
			cancellationPolicy: 'Politica de Cancelamento',
			clientInformation: 'Informações do Cliente',
			guest: 'Hóspede',
			information: (total) => `Informação do Quarto ${total}`,
			observations: 'Observações',
			name: 'Nome',
			generalConditions: 'Condições Gerais',
			invoiceAdvice: 'Esta reserva será faturada para sua empresa',
			generalConditionsText1: 'Aceito todas as',
			cancellationPolicyText1: 'Aceito a',
			finalize: 'Finalizar',
			errorMsg: 'Erro ao realizar a reserva! Entre em contato com nossos operadores!',
			generalConditionsDescription: `
			Taxas<br>
			* Todas as taxas estão inclusas, exceto taxa de quarto e/ou taxa ambiental que não estão inclusas<br>
			* Taxa de quarto deve ser paga diretamente pelo hospede no check out. A taxa de quarto é cobrada somente em alguns hotéis, o valor varia entre R$1,20 e R$9,00 por quarto, por noite. Esta taxa não é obrigatória e o hospede pode pedir no dia da chegada para excluir a cobrança da fatura do hotel.
			<br><br>


			  Plano de Alimentação<br>
			* Refeição no hotel não inclui bebida, exceto quando indicado.<br>
			* Tarifa de meia pensão e pensão completa não é valida para os dias 24 e 31 de Dezembro.
			<br><br>

			Horario de entrada / Horario de saida dos hoteis no Brasil<br>
			A maioria dos hotéis tem o horário de entrada fixado em 15:00 e o horário de saída às 12:00, mas existem algumas exceções. Se você necessita chegar mais cedo ou sair mais tarde é recomendável adicionar mais uma noite.
			<br><br>


			Acomodação em quarto triplo (capacidade para 3 pessoas):<br>
			No Brasil a maioria do quartos triplos são compostos por uma cama de casal e uma cama extra. Este tipo de acomodação é recomendável para famílias. Outras opções podem estar disponíveis, mas não são garantidas. Consulte no ato da reserva os diferentes tipos de acomodação disponíveis.
			<br><br
			Horário de funcionamento do escritório<br>
			* O escritório está aberto de 2a. a 6ª. feira de 08:00 às 19:00, depois deste horário qualquer solicitação urgente ou cancelamento deve ser informado por telefone, através do nosso Telefone celular de emergência, alem da solicitação enviada por e-mail.
			<br><br>

			Assistencia de Emergencia<br>
			* O  telefone celular de emergência está disponível para seus clientes 24 horas por dia / 7 dias da semana.<br>
			Telefone de emergencia: (21) 99662 0693 <br>
			Se estiver ligando do exterior deve discar  55 (21) 99662 0693 <br>
			Se você estiver ligando do Brazil mas de fora do Rio de Janeiro deve discar: (021 21) 99662 0693	<br>
			Se você estiver ligando da cidade do Rio de Janeiro você deve discar o numero local somente: 99662 0693 <br>`
		}
	},

	seeBookings: {
		initialDate: 'Data Inicial',
		finalDate: 'Data Final',
		initialCheckin: 'Checkin Inicial',
		finalCheckin: 'Checkin Final',
		reset: 'Limpar',
		search: 'Buscar',
		resultsText: (total, pages) => `Foram encontrados ${total} hotéis em ${pages} páginas.`,

		date: 'Data',
		checkin: 'Checkin',
		price: 'Preço',
		actions: 'Ações',

		seeYourBooking: 'Ver sua reserva',
		voucher: 'Voucher',
		invoice:'Fatura',
		cancel: 'Cancelar',

		documentErrorMsg: 'Erro ao carregar documento! ',
		cancelConfirmationText: (fileNumber) => `Deseja realmente cancelar a reserva ${fileNumber}?`,
		cancelSuccessMsg: (fileNumber) => `Reserva ${fileNumber} cancelada com sucesso!`,
		cancelFailMsg: 'Erro ao cancelar a reserva! Entre em contato com o operador da Blumar!',
	}
}



// WEBPACK FOOTER //
// ./src/assets/translationPt.js